import {k} from '../kaplay.js'
import {makeButton, makeCaseStudyPanel} from '../components.js'
import {formatMMSS} from '../utils.js'
import {cases} from '../data.js'
import {click} from '../music.js'


k.scene("result", ({targetScore, currentScore, time}) => {
  let sweetScore = currentScore.sweetness > targetScore.sweetness[0] && currentScore.sweetness < targetScore.sweetness[1] ? 1 : 0
  let tasteScore = currentScore.taste > targetScore.taste[0] && currentScore.taste < targetScore.taste[1] ? 1 : 0
  let weightScore = currentScore.weight > targetScore.weight[0] && currentScore.weight < targetScore.weight[1] ? 1 : 0

  let finalScore = sweetScore + tasteScore + weightScore
  console.log(finalScore)

  let verdict = ""

  if(finalScore >= 3) {
    verdict = "Excellent!"
    k.play("excellent")
  }
  else if (finalScore >= 2) {
    verdict = "Pretty good!"
    k.play("pretty_good")
  }
  else {
    verdict = "Too far off..."
    k.play("too_bad")
  }

  // const panel = k.add([
  //   k.rect(400, 600),
  //   k.anchor("center"),
  //   k.pos(k.width()/2, k.height()/2)
  // ])

  const title = k.add([
    k.text(verdict.toUpperCase(), {size: 55, font: "black", align: "center"}),
    k.color(k.BLACK),
    k.anchor("center"),
    k.pos(k.width()/2, 100),
  ])

  const timeSpent = k.add([
    k.text("Time spent: " + formatMMSS(time), {size: 30, align: "center"}),
    k.color(k.BLACK),
    k.anchor("center"),
    k.pos(k.width()/2, title.pos.y + 50),
    k.scale(0.7)
  ])

  const caseStudy = makeCaseStudyPanel(k.vec2(k.width()/2, timeSpent.pos.y + 110), cases[Math.floor(Math.random() * cases.length)])

  const tryAgain = makeButton("RETRY", k.vec2(k.width()/2+120, k.height()-100), false) 
  tryAgain.onClick(() => {
    k.go("game")
    click.play()
  })

  const home = makeButton("HOME", k.vec2(k.width()/2-120, k.height()-100), false) 
  home.onClick(() => {
    k.go("menu")
    click.play()
  })

  k.onDraw(() => {
    k.drawRect({
      width: k.width(),
      height: k.height(),
      color: k.Color.fromHex("#FFF3DE")
    })

    k.drawSprite({
      sprite: "logo",
      pos: k.vec2(10,10)
    })

    k.drawSprite({
      sprite: "table",
      anchor: "top",
      pos: k.vec2(k.width()/2,200)
    })
  })

})

// function makeCaseStudyPanel(_parent, _pos) {
//   const caseStudy = _parent.add([
//     k.rect(300, 300),
//     k.outline(2, k.BLACK),
//     k.anchor("top"),
//     k.pos(_pos)
//   ])
//
//   const caseStudyTitle = caseStudy.add([
//     k.text("Case study", {width: 300, size: 23, align: "center"}),
//     k.color(k.BLACK),
//     k.anchor("top"),
//     k.pos(0, 20)
// ])
//
//   const caseStudyContent = caseStudy.add([
//     k.text("Adding more protein while keeping taste good is a feat and requires lots of RnD. That's where we help.", {width: 300, size: 16, align: "center", lineSpacing: 16}),
//     k.color(k.BLACK),
//     k.anchor("top"),
//     k.pos(0, caseStudyTitle.pos.y + caseStudyTitle.height + 20)
//   ])
//
//   const caseStudyLink = caseStudy.add([
//     k.rect(200, 50),
//     k.color(k.CYAN),
//     k.outline(2, k.BLACK),
//     k.area(),
//     k.anchor("center"),
//     k.pos(0, caseStudyContent.pos.y + caseStudyContent.height + 60)
//   ])
//
//   caseStudyLink.add([
//     k.text("View case", {width: 300, size: 16, align: "center", lineSpacing: 16}),
//     k.color(k.BLACK),
//     k.anchor("center"),
//   ])
//
//   caseStudyLink.onClick(() => alert("Opens case study site, or\nShow lead capture form to send case study to"))
//
//   return caseStudy
// }
//
// function makeProductPanel(_parent, _pos) {
//   const caseStudy = _parent.add([
//     k.rect(300, 300),
//     k.outline(2, k.BLACK),
//     k.anchor("top"),
//     k.pos(_pos)
//   ])
//
//   const caseStudyTitle = caseStudy.add([
//     k.text("Sugarlike Sweetness", {width: 300, size: 23, align: "center"}),
//     k.color(k.BLACK),
//     k.anchor("top"),
//     k.pos(0, 20)
// ])
//
//   const caseStudyContent = caseStudy.add([
//     k.text("Did you know you can replace sugar with Sugarlike in 1:1 ratio? Saving you from lengthy trial and errors.", {width: 300, size: 16, align: "center", lineSpacing: 16}),
//     k.color(k.BLACK),
//     k.anchor("top"),
//     k.pos(0, caseStudyTitle.pos.y + caseStudyTitle.height + 20)
//   ])
//
//   const caseStudyLink = caseStudy.add([
//     k.rect(200, 50),
//     k.color(k.CYAN),
//     k.outline(2, k.BLACK),
//     k.area(),
//     k.anchor("center"),
//     k.pos(0, caseStudyContent.pos.y + caseStudyContent.height + 60)
//   ])
//
//   caseStudyLink.add([
//     k.text("View product", {width: 300, size: 16, align: "center", lineSpacing: 16}),
//     k.color(k.BLACK),
//     k.anchor("center"),
//   ])
//
//   caseStudyLink.onClick(() => alert("Opens product page"))
//
//   return caseStudy
// }

